module.exports = __webpack_public_path__ + "img/SEJ_Eventos_norificacion_generica.0ad5ca82.svg";